// THIS FOR Single Approval
import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
  SimpleChanges,
  EventEmitter
} from '@angular/core';

import { HttpClient } from '@angular/common/http';
import {map, switchMap, tap} from 'rxjs/operators';

import * as BpmnJS from 'bpmn-js/dist/bpmn-navigated-viewer.production.min.js';
import { from, Observable, Subscription } from 'rxjs';
import {data} from 'jquery';
import {SweetAlertService} from "../../services/common/sweet-alert.service";

@Component({
  selector: 'app-diagram-delegate-doc',
  template: `
    <div class="row">
      <div class="col-12" style="height: 450px">
        <div #ref class="diagram-container"></div>
      </div>
      <div class="col-12">
        <div style="position: absolute;bottom: 50px;right: 20px;display: grid;grid-gap: 3px;">
          <button id="btnzoomin" class="btn btn-primary btn-icon btn-sm" (click)="zoomIn()">
            <i class="ki ki-plus"></i>
          </button>
          <button id="btnfit" class="btn btn-primary btn-icon btn-sm" (click)="zoomOut()">
            <i class="ki ki-minus"></i>
          </button>
          <button id="btnzoomout" class="btn btn-primary btn-icon btn-sm" (click)="zoomReset()">
            <i class="ki ki-refresh"></i>
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
    .diagram-container {
      height: 100%;
      width: 100%;
    }
    `,
    `
    .bac {
        background-color: red;
    }`
  ]
})
export class DiagramDelegateAppComponent implements AfterContentInit, OnChanges, OnDestroy {
  private bpmnJS: BpmnJS;
  private overlays: any;
  private elementRegis: any;
  cnvs = 0;

  @ViewChild('ref', { static: true }) private el: ElementRef;
  @Output() private importDone: EventEmitter<any> = new EventEmitter();

  @Input() private url: string;
  @Input() private urlDashboard: string;
  @Input() private myHeader: any;

  constructor(private http: HttpClient) {
    // single approval custom
    this.bpmnJS = new BpmnJS();

    this.bpmnJS.on('import.done', ({ error }) => {
      if (!error) {
        this.bpmnJS.get('canvas').zoom('fit-viewport');
        this.overlays = this.bpmnJS.get('overlays');
        this.elementRegis = this.bpmnJS.get('elementRegistry');
        this.cnvs = this.bpmnJS.get('canvas').zoom('fit-viewport');
      }
    });
  }

  ngAfterContentInit(): void {
    this.bpmnJS.attachTo(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url) {
      this.loadUrl(changes.url.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.bpmnJS.destroy();
  }

  zoomIn() {
    if (this.cnvs < 1.5) {
      this.cnvs += 0.1;
    }
    this.bpmnJS.get('canvas').zoom(this.cnvs);
  }

  zoomOut() {
    if (this.cnvs > 0.3) {
      this.cnvs -= 0.1;
    }
    this.bpmnJS.get('canvas').zoom(this.cnvs);
  }

  zoomReset() {
    this.cnvs = this.bpmnJS.get('canvas').zoom('fit-viewport');
    this.bpmnJS.get('canvas').zoom(this.cnvs);
  }

  /**
   * Load diagram from URL and emit completion event
   */
  loadUrl(url: string): Subscription {
    const urlXml = `${url}`;
    return (
      this.http.get(urlXml, {
        headers: this.myHeader,
        responseType: 'text'
      }).pipe(
        switchMap((xml: string) => this.importDiagram(xml)),
        map(result => result.warnings),
      ).subscribe(
        async (warnings) => {
          this.http.get(this.urlDashboard, {
            headers: this.myHeader
          }).subscribe((res: any) => {
            const objData = res.data.object
            const dataDash = objData.tasks;
            let obj = new Object();
            obj['Drafting'] = (dataDash.Drafting ? 1 : 0);
            obj['Review'] = (dataDash.reviewSequence ? 1 : 0) + (dataDash.reviewParalel ? 1 : 0);
            obj['Approval'] = (dataDash.headApprovalSequence ? 1 : 0) + (dataDash.headApprovalParalel ? 1 : 0) + (dataDash.groupHeadApprovalSequence ? 1 : 0) +  (dataDash.groupHeadApprovalParalel ? 1 : 0) + (dataDash.chiefApprovalSequence ? 1 : 0) + (dataDash.chiefApprovalParalel ? 1 : 0);
            obj['Acknowledge'] = (dataDash.acknowledgeSequence ? 1 : 0) + (dataDash.acknowledgeParalel ? 1 : 0);
            obj['Revise'] = (dataDash.revise ? 1 : 0);
            obj['reviewReviseDocument'] = (dataDash.reviewReviseParalel ? 1 : 0);
            obj['approved'] = (dataDash['ENDED - approved'] ? 1 : 0);
            obj['rejected'] = (dataDash['ENDED - rejected'] ? 1 : 0);

            const arrId = ['Drafting', 'Review', 'Approval', 'Acknowledge', 'reviewReviseDocument', 'Revise', 'approved', 'rejected'];
            for (const el of arrId) {
              if (obj[el]) {
                let shape = this.elementRegis.get(el);
                let overlayHtml = $('<div id="' + el + '" style="background-color: #1dc5bd; opacity: 0.6; border-radius: 8px;">&nbsp;</div>')
                  .css({
                    width: shape.width,
                    height: shape.height
                  });

                this.overlays.add(el, {
                  position: {
                    top: 0,
                    left: 0
                  },
                  html: overlayHtml
                });

                overlayHtml.click((e) => {
                  this.importDone.emit({
                    type: 'click',
                    warnings: el
                  });
                });
              }
            }
            this.importDone.emit({
              type: 'success',
              warnings
            });
          }, (err) => {
            this.importDone.emit({
              type: 'error',
              error: err
            });
          })
        },
        (err) => {
          this.importDone.emit({
            type: 'error',
            error: err
          });
        }
      )
    );
  }

  private importDiagram(xml: string): Observable<{warnings: Array<any>}> {
    return from(this.bpmnJS.importXML(xml) as Promise<{warnings: Array<any>}>);
  }
}
